import ApiService from '@/services/core/api.service'

const UtilitySMSService = {
  async get (query) {
    return ApiService.get(`agent/utility-sms?${query}`)
  },

  async post (payload) {
    return ApiService.post('agent/utility-sms', payload)
  },

  async put (payload) {
    return ApiService.put(`agent/utility-sms/${payload.id}`, payload)
  }
}

export default UtilitySMSService
